import { render, staticRenderFns } from "./ManagerDepartures.vue?vue&type=template&id=299af4be&scoped=true&"
import script from "./ManagerDepartures.vue?vue&type=script&lang=js&"
export * from "./ManagerDepartures.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDepartures.vue?vue&type=style&index=0&id=299af4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299af4be",
  null
  
)

export default component.exports